// src/components/Hero.js
import React from "react";
import Slider from "react-slick";

// IMPORTAR los CSS de slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slide1 from "../assets/pc/slide/1920x600/Slide1.png";
import Slide1R from "../assets/celu/Home/slide/Slide1.png"
import "../layouts/Hero.css";
const isMobile = window.innerWidth < 768;
let Slidex = Slide1
if (isMobile) {
	Slidex = Slide1R
}
const slides = [Slidex];

function Hero() {
  const settings = {
	// dotsClass: "slick-dots custom-dots",
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    pauseOnHover: true,
  };

  return (
    <section className="hero-section" id="section1">
      <div className="slider-wrapper">
        <Slider {...settings}>
          {slides.map((imgSrc, idx) => (
            <div key={idx} className="slide-item">
              <img style={{width:'100%'}} src={imgSrc} alt={`Slide ${idx + 1}`} />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default Hero;
